import ApplicationController from '../application_controller'

class SessionController extends ApplicationController {
  static targets = ['lifetime']

  connect () {
    document.querySelectorAll('input[name="session_policy"]').forEach(input => {
      input.addEventListener('click', (e) => { this.handlePolicySelector(e.target) })
    })
  }

  handlePolicySelector (target) {
    if (target.value === '0') {
      this.lifetimeTarget.value = 0
      this.lifetimeTarget.readOnly = true
    } else {
      this.lifetimeTarget.readOnly = false
    }
  }
}

export default SessionController
